import React from 'react';
import { Path, Rect, Svg } from 'react-native-svg';

export interface CalendarBadgeIconProps {
    size?: number;
}

export const CalendarBadgeIcon: React.FC<CalendarBadgeIconProps> = ({
    size = 40,
}) => {
    return (
        <Svg width={size} height={size} viewBox="0 0 40 40" fill="none">
            <Rect width={40} height={40} fill="#F5F5F5" rx={20} />
            <Path
                stroke="#333"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.6}
                d="M19.167 21.667H20V25m3.333-13.333V15M12.5 18.334h15m-10.833-6.667V15m-2.5-1.666h11.666c.92 0 1.667.746 1.667 1.666v11.667c0 .92-.746 1.667-1.667 1.667H14.167c-.92 0-1.667-.747-1.667-1.667V15c0-.92.746-1.666 1.667-1.666Z"
            />
        </Svg>
    );
};

export default CalendarBadgeIcon;
